import appmaker from '@appmaker/core/index';
import Home from './routes/HomeWrapper';
import { BeakerIcon } from '@heroicons/react/solid';
import AsyncSelectMenu from './new/components/AsyncSelectMenu';

const plugin = {
	id: '@appmaker/app-builds',
	name: 'App Builds',
	activate: () => {
		// Server-paginated / server-searched select, used by the SDK fields on the
		// app-build form. Scoped to this package so the shared appmaker/select-menu
		// block stays untouched.
		appmaker.registerAppmakerFrontEndBlock('appmaker/async-select-menu', {
			title: 'Async Select Menu',
			Block: AsyncSelectMenu,
		});
		appmaker.registerRoute({
			routeName: '/app-builds',
			component: Home,
		});
		/**
		 * Menu Items
		 */
		appmaker.registerSideBarMenu(
			{
				name: 'App Builds',
				routeName: '/app-builds',
				icon: BeakerIcon,
			},
			8
		);
	},
};

export default plugin;
